export default __webpack_public_path__ + "static/media/encuestas-generadas.df5a631d.jpeg";